import {create} from 'zustand';
import {persist} from "zustand/middleware";

interface ConfigStore {
    theme: 'dark' | 'light';
    toggleTheme: () => void;
}

export const useConfigStore = create<ConfigStore>()(
    persist(
        (set) => ({
            theme: 'light',
            toggleTheme: () => set((state: {
                theme: 'dark' | 'light';
            }) => ({theme: state.theme === 'light' ? 'dark' : 'light'}))
        }),
        {
            name: "config"
        }
    ))
;